import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService, hasToolsAccess } from '../services/session.service';

// Gate the in-app tools behind the admin-managed access window. By default
// (toolsAccessUntil = null) access is OPEN, so nothing changes for existing
// users; the guard only blocks a user whose window the admin set to closed /
// already expired. Runs after authGuard, so a session is present.
export const toolsAccessGuard: CanActivateFn = (route, state) => {
  const sessionService = inject(SessionService);
  const router = inject(Router);
  // lang lives on the :lang parent; the tools child doesn't inherit it, so read
  // it off the target URL (/he/app/tools -> 'he'), falling back to 'en'.
  const lang = (state.url.match(/^\/(en|he)(?:\/|$)/)?.[1]) || 'en';

  if (hasToolsAccess(sessionService.session?.user)) {
    return true;
  }

  console.log('toolsAccessGuard: tools access closed/expired, redirecting home');
  return router.createUrlTree([lang, 'app', 'home'], {
    queryParams: { toolsLocked: 1 },
  });
};
